/* eslint-disable */
$(document).ready(function () {
  // Search
  $('.searchToggle').on('click', function () {
    var $searchEl = $('.headerSearch');
    $searchEl.toggleClass('--isOpen');
    var isOpen = $searchEl.hasClass('--isOpen');

    if (isOpen) {
      $('body').addClass('--noScroll');
      setTimeout(function () {
        $('.headerSearch__input').focus();
      }, 200);
    } else {
      $('body').removeClass('--noScroll');
    }
  });


  // Accessibility menu
  var traps = [];

  $('.header__navItem').each(function(i, obj) {
    if ($(obj).hasClass('--hasDropdown')) {
      var id = $(obj).find('.header__dropdownList').attr('id');
      var control = $(obj).find('button.header__navLink')[0];

      traps[id] = window.focusTrap.createFocusTrap(`#${id}`, {
        clickOutsideDeactivates: true,

        onActivate: function onActivate() {
          $(`#${id}`).addClass("--isShow");
          $(control).attr('aria-expanded', true);
        },

        // There is a delay between when the class is applied and when the element is focusable
        checkCanFocusTrap: function checkCanFocusTrap(trapContainers) {
          var results = trapContainers.map(function (trapContainer) {
            return new Promise(function (resolve) {
              var interval = setInterval(function () {
                if (getComputedStyle(trapContainer).visibility !== 'hidden') {
                  resolve();
                  clearInterval(interval);
                }
              }, 5);
            });
          }); // Return a promise that resolves when all the trap containers are able to receive focus

          return Promise.all(results);
        },

        onDeactivate: function onDeactivate() {
          $(`#${id}`).removeClass("--isShow");
          $(control).attr('aria-expanded', false);
        },
      });
    }
  });

  $('button.header__navLink').keypress(function(e) {
    if (e.which == 13 || e.which == 32) {
      var id = $(this).attr('aria-controls');
      traps[id].activate();
    }
  });
});
/* eslint-enable */
